import { SelectionPhoto } from "../../types/selection/selection";

export function orderSelectionByDate(selectionPhotos: SelectionPhoto[]): SelectionPhoto[] {
  const photoSelection = [...selectionPhotos];
  return photoSelection.sort((photoA, photoB) => {
    const photoALastModified = photoA.lastModified || Date.now();
    const photoBLastModified = photoB.lastModified || Date.now();
    return photoALastModified - photoBLastModified;
  });
}
